<!--<div class="activity">-->
  <ng-content [class.page_content]="true">

  </ng-content>
<!--</div>-->
